<!--  -->
<template>
	<div class="container">
		<div class="search-container tr" v-if="isEdit">
			<img class="icon-img ml7" src="@/assets/images/delete.png" @click="handleDelete" title="删除" alt="">
			<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="">
		</div>
		<!-- style="width: 99%" -->
		<div class="table-container">
			<el-table
				v-if="tableData.length>0"
				ref="multipleTable"
				v-el-table-infinite-scroll="tableLoad"
				:height="height"
				:infinite-scroll-distance="50"
				:infinite-scroll-immediate="false"
				:data="tableData"
				:row-class-name="tabRowClassName"
				:cell-style="cellStyle"
				:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
				:row-key="(row) => {return row.dataKey}"
				@selection-change="handleSelectionChange"
				@cell-click="handleCellClick"
				border
				style="width: 100%">
				<!--  -->
				<el-table-column type="selection" width="50" :reserve-selection="true" align="center" :selectable="selectable"></el-table-column>
				<el-table-column v-show="tableData" v-for="(title, index) in titles" :key="index" :show-overflow-tooltip="true" :label="title.title" :prop="title.prop" sortable :column-key="title.prop">
					<template slot-scope="scope">
						{{scope.row[title.prop]}}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<roleEdit ref="roleEdit" @getList="getList"></roleEdit>
	</div>
</template>

<script>
	import {debounce} from '@/utils/debounce'
	import { hasPermission } from '@/utils/permission'
	import roleEdit from './components/role-edit.vue'
	export default {
		name:'roleManagement',
		components: {
			roleEdit
		},
		data() {
			return {
				height: 500,
				pageNo: 1,
				pageSize: 40,
				totalPage: 100,
				tableData: [],
				titles: [],
				multipleSelection: [],
				isEdit:false
			}
		},
		created() {
			this.height = window.innerHeight - 145;
			this.getList();
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		methods: {
			tabRowClassName({row,rowIndex}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({row, column, rowIndex, columnIndex}) {
				if(columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 新增/编辑
			handleEdit() {
				this.$refs.roleEdit.init();
			},
			// 获取列表
			getList(type) {
				let that = this;
				that.$request.post(
					"roleListPage",
					true, {
						pageNo: that.pageNo,
						pageSize: that.pageSize
					}
				)
				.then((res) => {
					if (res) {
						if (type == 'scroll') {
							that.tableData = that.tableData.concat(res.data.tableDatas);
						} else {
							if (res.data && res) {
								that.titles = res.data.titles
								that.tableData = res.data.tableDatas
								that.totalPage = res.data.totalPage
							} else {
								that.titles = []
								that.tableData = []
							}
						}
						that.titles  = that.titles.map((item, index) => { 
									return { 
										title: item.title, 
										prop: 'tr' + index,
										maxWidth:item.maxWidth, 
									} 
								})
						that.tableData.forEach(item => {
							for (let i = 0; i < that.titles.length; i++) {
								item['tr' + i] = item.datas[i] || ''
							}
						})
					}
				})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				if(this.pageNo >= this.totalPage) {
					return
				}
				this.pageNo++;
				this.getList('scroll');
			}, 100, true),
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 禁止选择
			selectable(row,index) {
				if(!['1','2','3'].includes(row.dataKey)) {
					return true
				}
			},
			// 点击每行数据处理
			handleCellClick(row, column, cell, event) {
				if(column.label == '角色名称') {
					this.$refs.roleEdit.init(row.dataKey);
				}else {
					if(!['1','2','3'].includes(row.dataKey)){
						this.$refs.multipleTable.toggleRowSelection(row);
					}
				}
			},
			// 删除
			handleDelete() {
				if(this.multipleSelection.length == 0) {
					return
				}
				this.$confirm('已赋予角色的用户将失去对应的权限', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let roleIds = [];
					this.multipleSelection.forEach(item => {
						roleIds.push(item.dataKey);
					})
					let that = this;
					that.$request.post(
						"deleteRole",
						true, {
							roleIds: roleIds
						}
					)
					.then((res) => {
						if (res) {
							if(that.tableData.length > 0){
								that.$refs.multipleTable.clearSelection();
								that.$refs.multipleTable.bodyWrapper.scrollTop = 0;
							}
							that.pageNo = 1;
							that.getList();
						}
					})
				}).catch(() => {

				});
			}
		},
	}

</script>

<style lang='scss' scoped>
	.container {
		// width: 99%;
		background: #fff;
		box-sizing: border-box;
		margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;
		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding:0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.red {
		width: 50px;
		height: 20px;
		background: #D9001B;
	}

	.blue {
		width: 50px;
		height: 20px;
		background: #02A7F0;
	}

	.search-container {
		padding: 8px;
	}

</style>
